module.exports = __webpack_public_path__ + "assets/img/00191.cc820724.png";